import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface CartState {
  cartData: {
    cartItems: CartItem[];
    totalItem: number;
    totalItemSimple: number;
    totalItemPresc: number;
    prescData: CartItem[];
    grandTotal: string;
    itemTotalMRP: string;
    itemDiscountMRP: string;
    deliveryCharge: number;
  };
  openDeleteModal: boolean;
}

const initialState: CartState = {
  cartData: {
    cartItems: [],
    totalItem: 0,
    totalItemSimple: 0,
    totalItemPresc: 0,
    prescData: [],
    grandTotal: "0.00",
    itemTotalMRP: "0.00",
    itemDiscountMRP: "0.00",
    deliveryCharge: 0,
  },
  openDeleteModal: false,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCart: (state, action: PayloadAction<CartResponse>) => {
      state.cartData = {
        cartItems: action.payload.data,
        totalItem: action.payload.total_item,
        totalItemSimple: action.payload.total_item_simple,
        totalItemPresc: action.payload.total_item_Presc,
        prescData: action.payload.Prescdata,
        grandTotal: action.payload.GrandTotal,
        itemTotalMRP: action.payload.ItemTotalMRP,
        itemDiscountMRP: action.payload.ItemDiscountMRP,
        deliveryCharge: action.payload.DeliveryCharge,
      };
    },

    handleCloseDeleteModal: (state) => {
      state.openDeleteModal = false;
    },

    handleOpenDeleteModal: (state) => {
      state.openDeleteModal = true;
    },

  },
});

export const {
  setCart,
  handleCloseDeleteModal,
  handleOpenDeleteModal,
} = cartSlice.actions;

export default cartSlice;
